import { render } from "./NextBtn.vue?vue&type=template&id=22088466&ts=true"
import script from "./NextBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextBtn.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/NextBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22088466"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22088466', __exports__)) {
    api.reload('22088466', __exports__)
  }
  
  module.hot.accept("./NextBtn.vue?vue&type=template&id=22088466&ts=true", () => {
    api.rerender('22088466', render)
  })

}


export default __exports__